import React, { useState, useEffect } from 'react';
import { analyticsAPI } from '../services/api';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import '../styles/AnalyticsDashboard.css';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8'];

const AnalyticsDashboard = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const response = await analyticsAPI.getStats();
            setStats(response.data);
        } catch (error) {
            console.error("Error fetching analytics:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="analytics-loading">⏳ جاري تحميل التحليلات...</div>;
    if (!stats) return null;

    return (
        <div className="analytics-dashboard fade-in">
            <div className="analytics-header">
                <h2>📊 لوحة التحليلات المتقدمة</h2>
                <p>نظرة شاملة على أداء دوراتك وطلابك</p>
            </div>

            <div className="charts-grid">
                {/* Course Popularity Chart */}
                <div className="chart-card">
                    <h3>أكثر الدورات شعبية</h3>
                    <div className="chart-container">
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={stats.courseStats}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="title" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="student_count" name="عدد الطلاب" fill="#4F46E5" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>

                {/* Exam Performance Chart */}
                <div className="chart-card">
                    <h3>أداء الطلاب في الامتحانات (متوسط الدرجات)</h3>
                    <div className="chart-container">
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={stats.examStats} layout="vertical">
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis type="number" domain={[0, 100]} />
                                <YAxis dataKey="title" type="category" width={100} />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="average_score" name="متوسط الدرجة" fill="#10B981" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div>

            {/* Recent Activity Section */}
            <div className="recent-activity-section">
                <h3>آخر النشاطات</h3>
                <div className="activity-list">
                    {stats.recentEnrollments.length > 0 ? (
                        stats.recentEnrollments.map((activity, index) => (
                            <div key={index} className="activity-item">
                                <div className="activity-icon">🎓</div>
                                <div className="activity-details">
                                    <span className="student-name">{activity.full_name}</span>
                                    <span className="action-text">انضم إلى دورة</span>
                                    <span className="course-name">{activity.course_title}</span>
                                </div>
                                <span className="activity-time">
                                    {new Date(activity.enrolled_at).toLocaleDateString('ar-EG')}
                                </span>
                            </div>
                        ))
                    ) : (
                        <p className="no-activity">لا يوجد نشاطات حديثة.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AnalyticsDashboard;
